import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { AccountingPage } from '@/features/accounting/pages/AccountingPage'
const searchSchema = z.object({
  tab: z.enum(['journal-entries', 'reports', 'chart-of-accounts', 'periods', 'treasury']).catch('journal-entries'),
  shift: z.string().optional(),
})
export const Route = createFileRoute('/_app/accounting/')({
  validateSearch: searchSchema,
  component: AccountingPage,
})
